/**
 * @module profile/components/brief/head
 */
import React, { PropTypes } from 'react';
import Tooltip from 'react-tooltip';
import { v4 } from 'node-uuid';
import classnames from 'classnames';
import Feedback from 'common/containers/project_feedback';
import Money from 'common/components/money';
import { isMobile } from 'common/utils';

/**
 * Project brief header
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 *
 * @return {void}
 */
const BriefHead = ({ project, awards, rankedTips, toggleStatsModal }) => {
  const award = parseInt(project.total_awards_and_tips || 0, 10);
  const hasStats = !project.is_one_to_one;
  const showAwardTooltip = awards.length + rankedTips.length > 1;

  return (
    <div className="brief-header">
      <div className="row">
        <ul className="large-16 column stats-block">
          <li>
            <span className="brief-header-label">
              { project.assured ?
                <span className="brief-header-label text-success">Assured</span> :
                'Award' }
            </span>
            <span className="brief-header-stat">
              <span className="dollar-sign">$</span>{award}
              { showAwardTooltip && <button
                data-tip={true}
                data-for="award-breakdown"
                className="award-tooltip-trigger"
                data-event={isMobile()? "click" : undefined}
              >
                <span>$$</span>
              </button> }
              { showAwardTooltip && <Tooltip
                id="award-breakdown"
                class="award-tooltip"
                place="right"
                type="light"
                effect="solid"
              >
                <ul>
                  { awards.map(({ feature }, index) => (
                  <li key={v4()}>
                    <span>Award{awards.length > 1? ` ${index + 1}` : ''}:</span>{' '}
                    <strong>
                      <Money className="value" value={feature.value} />
                    </strong>
                  </li>
                  )) }
                  { rankedTips.map(({ feature }, index) => (
                  <li key={v4()}>
                    <span>Tip{rankedTips.length > 1? ` ${index + 1}` : ''}:</span>{' '}
                    <strong>
                      <Money className="value" value={feature.value} />
                    </strong>
                  </li>
                  )) }
                </ul>
              </Tooltip> }
            </span>
          </li>
          {
          /* TODO - show this for creatives if not participating, if participating, show "your best"
          <li>
            <span className="brief-header-label">
              Time Left
            </span>
            <span className="brief-header-stat">
              {deadlineLabel}
            </span>
          </li> */}

          <li>
            <span className="brief-header-label">
              { project.entry_count === 1 ? 'Entry' : 'Entries' }
            </span>
            <span className="brief-header-stat">
              { project.entry_count }
            </span>
          </li>
          <li>
            {/* TODO - Hide this for creatives */}
            <span className="brief-header-label">
              { project.creative_count === 1 ? 'Creative' : 'Creatives' }
            </span>
            <span className="brief-header-stat">{ project.creative_count }</span>
          </li>
          <li className={classnames("feedback-item", { "with-stats": hasStats })}
              onClick={hasStats? toggleStatsModal : undefined}>
            <span className="brief-header-label">
              Feedback{ hasStats? "/Stats" : "" }
            </span>
            <span className="brief-header-stat feedback">
              <Feedback project={project} showLabel={true}/>
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

BriefHead.propTypes = {
  project: PropTypes.object,
  awards: PropTypes.array,
  rankedTips: PropTypes.array,
  toggleStatsModal: PropTypes.func,
};

export default BriefHead;



// WEBPACK FOOTER //
// ./project/components/brief/head.jsx